/** The code for the reading pages, split from Home's and the board's. */
export const loadAboutPage = () => import('./AboutPage');
export const loadPrivacyPage = () => import('./PrivacyPage');
